"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var jquery_1 = __importDefault(require("jquery"));
var debounce_1 = require("../tools/debounce");
var Tooltip = (function () {
    function Tooltip() {
        this.root = document.documentElement;
        this.$doc = (0, jquery_1.default)(this.root);
        this.sideOffset = 10;
        this.tooltipElement = (0, jquery_1.default)('<div class="tooltip">'.concat('<span class="tooltip-pointer"></span>', '<span class="tooltip-close"></span>', '<div class="tooltip-content"></div>', '</div>'));
        this.tooltipPointer = this.tooltipElement.find('.tooltip-pointer');
        this.tooltipContent = this.tooltipElement.find('.tooltip-content');
        this.activeEl = null;
        this.currentOrientation = 'center';
        this.timestamp = null;
        if (!Tooltip.tooltipInstance) {
            Tooltip.tooltipInstance = this;
            this.init();
        }
        else {
            throw new Error("Error: Instantiation failed: Use <class>.getInstance() instead of new.");
        }
    }
    Tooltip.getInstance = function () {
        if (!this.tooltipInstance) {
            this.tooltipInstance = new Tooltip();
        }
        return this.tooltipInstance;
    };
    Tooltip.prototype.init = function () {
        var _this = this;
        this.$doc.on('click', '.tooltip-close', function () { return _this.hide(); });
        this.$doc.on('click', function (e) { return _this.handleTooltipToggle(e); });
        (0, jquery_1.default)(window).resize((0, debounce_1.debounce)(function () { return _this.updatePosition(); }));
    };
    Tooltip.prototype.hide = function () {
        this.activeEl = null;
        this.tooltipElement.css({
            left: -9999,
            right: 'auto'
        });
        this.setContent('');
        clearTimeout(this.hideTimeoutId);
    };
    Tooltip.prototype.show = function (content, relativeEl, className, displayDuration) {
        this.timestamp = +new Date();
        className = className || '';
        className = 'tooltip ' + className;
        if (content) {
            this.setContent(content);
        }
        this.tooltipElement.appendTo(document.body);
        this.tooltipElement.show();
        this.tooltipElement.attr('class', className);
        if (relativeEl) {
            this.position(relativeEl);
        }
        clearTimeout(this.hideTimeoutId);
        if (displayDuration) {
            this.hideTimeoutId = setTimeout(function () {
                Tooltip.getInstance().hide();
            }, displayDuration);
        }
    };
    Tooltip.prototype.handleTooltipToggle = function (event) {
        if ((this.timestamp + 200) < (+new Date())
            && !jquery_1.default.contains(this.tooltipElement[0], event.target)) {
            this.hide();
        }
    };
    Tooltip.prototype.setContent = function (content) {
        this.tooltipContent.html(content);
    };
    Tooltip.prototype.position = function (relativeEl) {
        relativeEl = (0, jquery_1.default)(relativeEl);
        this.activeEl = relativeEl;
        var width = this.tooltipElement.width();
        var widthOffset = width / 2;
        var offset = relativeEl.offset();
        var xOffset = offset.left + (relativeEl.outerWidth() / 2);
        var yOffset = offset.top + relativeEl.outerHeight();
        var clientWidth = this.root.clientWidth;
        var rightOffset = "auto";
        var pointerOffset = 0;
        if (clientWidth < 640) {
            xOffset = this.sideOffset;
            rightOffset = this.sideOffset;
            pointerOffset = (offset.left + (relativeEl.outerWidth() / 2)) - xOffset;
            this.currentOrientation = 'center';
        }
        else if (clientWidth < (xOffset + widthOffset)) {
            xOffset = clientWidth - (width + 5);
            pointerOffset = (offset.left + (relativeEl.outerWidth() / 2)) - xOffset;
            this.currentOrientation = 'right';
        }
        else if (xOffset - widthOffset < 0) {
            pointerOffset = xOffset - 5;
            xOffset = 5;
            this.currentOrientation = 'left';
        }
        else {
            xOffset = xOffset - widthOffset;
            pointerOffset = widthOffset;
            this.currentOrientation = 'center';
        }
        this.tooltipElement.attr("style", "");
        this.tooltipElement.css({
            top: yOffset,
            left: xOffset
        });
        this.tooltipPointer.css({
            left: pointerOffset
        });
    };
    Tooltip.prototype.updatePosition = function () {
        if (!this.activeEl) {
            return;
        }
        this.position(this.activeEl);
    };
    return Tooltip;
}());
exports.Tooltip = Tooltip;
